<template>
  <v-speed-dial
      v-if="!disabled"
      class="menu"
      v-model="fab"
      direction="bottom">
    <template v-slot:activator>
      <default-button :color="activateColor" :outline="fab" :disabled="disabled" :loading="loading">
        <slot>Grab</slot>
      </default-button>
    </template>
    <template v-for="option in availableOptions">
      <default-button :key="option.minutes" :color="optionsColor" @click="$emit('time', option.minutes)">
        {{ option.label }}
      </default-button>
    </template>
  </v-speed-dial>
  <!-- This is kinda awkward, but the v-speed-dial component doesn't have a disabled prop
       So instead, we replace the button with a new one that doesn't have any functionality -->
  <default-button
      v-else
      :disabled="disabled">
    Grab
  </default-button>
</template>

<script>
import DefaultButton from './DefaultButton';

export default {
  name: 'TimeButtons',
  components: {DefaultButton},
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    grab: {
      type: Boolean,
      default: false
    },
    freeMins: {
      type: Number,
      default: 60
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fab: false,
      options: [
        {minutes: 15, label: '15 mins'},
        {minutes: 30, label: '30 mins'},
        {minutes: 60, label: '1 hour'}
      ]
    };
  },
  computed: {
    activateColor() {
      if (this.grab) {
        return 'green';
      }
      return 'red';
    },
    availableOptions() {
      if (this.freeMins < 15) {
        return [{
          minutes: this.freeMins,
          label: `${this.freeMins} mins`
        }];
      }
      return this.options.filter(o => o.minutes <= this.freeMins);
    },
    optionsColor() {
      return this.grab ? 'green' : 'red';
    }
  },
  watch: {
    fab() {
      this.$emit('input', this.fab);
    }
  }
};
</script>

<style scoped>
  .menu {
    display: inline-block;
    width: var(--button-width);
  }
</style>
